import { createApp } from "vue";
import App from "@/App.vue";
import { App as CapacitorApp } from "@capacitor/app";
import tracker from "@/plugins/openReplay";
import store from "@/store"; //vuex
import router from "./router"; //router
import LogRocket from "logrocket";

tracker.start();

CapacitorApp.addListener("backButton", ({ canGoBack }) => {
  //더이상 뒤로갈 수 없는 경우에는 뒤로가기 이벤트가 막히도록 처리한다.
  if (canGoBack) {
    window.history.back();
  }
});

LogRocket.init("myclassapp/myclassapp-z80nl");
const app = createApp(App).use(router);
app.use(store);
app.mount("#app");
